import { RouterChild } from '@/router';

export default [
  {
    name: 'time-allocation',
    path: 'time-allocation',
    component: () => import('./views/TimeAllocation.vue')
  } as RouterChild
];
